<template>
 <div class="container-fluid mt-3" dir="rtl">
    
    <!-- 1. لوحة التحكم (تصميم متجاوب Grid System) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-header bg-white py-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h5 class="mb-0 text-primary fw-bold fs-6 fs-md-5">
            <i class="fas fa-users-cog ms-2"></i> إدارة اللجان وتوزيع الطلاب
        </h5>
        <span class="badge bg-light text-dark border shadow-sm">{{ countStudent }} طالب</span>
      </div>
      
      <div class="card-body">
        
        <!-- الصف الأول: الإعدادات والترتيب -->
        <div class="row g-3 align-items-end">
          
          <!-- أرقام الإعدادات -->
          <div class="col-6 col-md-3">
            <label class="form-label fw-bold small">سعة اللجنة</label>
            <div class="input-group input-group-sm">
                <input type="number" v-model.number="settings.capacity" class="form-control text-center fw-bold" placeholder="20" />
                <span class="input-group-text">طالب</span>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <label class="form-label fw-bold small">بداية الترقيم</label>
            <div class="input-group input-group-sm">
                <span class="input-group-text">لجنة رقم</span>
                <input type="number" v-model.number="settings.start_committee" class="form-control text-center fw-bold" placeholder="1" />
            </div>
          </div>
          
          <!-- أزرار الترتيب (راديو كارد) -->
          <div class="col-12 col-md-6">
              <label class="form-label fw-bold small text-primary d-block mb-1">نظام ترتيب الكشوف</label>
              <div class="d-flex flex-column flex-sm-row gap-2">
                  
                  <div class="form-check card-radio flex-fill">
                      <input class="form-check-input d-none" type="radio" name="sortMode" id="mode1" value="gender_all" v-model="settings.sort_mode">
                      <label class="form-check-label btn btn-outline-secondary btn-sm w-100 py-2 d-flex align-items-center justify-content-center" for="mode1">
                          <i class="fas fa-venus-mars me-2"></i> نوع
                      </label>
                  </div>
                  
                  <div class="form-check card-radio flex-fill">
                      <input class="form-check-input d-none" type="radio" name="sortMode" id="mode2" value="school_gender" v-model="settings.sort_mode">
                      <label class="form-check-label btn btn-outline-secondary btn-sm w-100 py-2 d-flex align-items-center justify-content-center" for="mode2">
                          <i class="fas fa-school me-2"></i> مدرسة
                      </label>
                  </div>
                  
                  <div class="form-check card-radio flex-fill">
                      <input class="form-check-input d-none" type="radio" name="sortMode" id="mode3" value="serial" v-model="settings.sort_mode">
                      <label class="form-check-label btn btn-outline-secondary btn-sm w-100 py-2 d-flex align-items-center justify-content-center" for="mode3">
                          <i class="fas fa-list-ol me-2"></i> تسلسل
                      </label>
                  </div>

              </div>
          </div>
        </div>

        <!-- الصف الثاني: اختيار الأعمدة (شكل Tags) -->
        <div class="mt-4 p-3 bg-light rounded border">
          <label class="form-label fw-bold d-block mb-2 small text-muted">
            <i class="fas fa-columns ms-1"></i> اختر الأعمدة للعرض:
          </label>
          <div class="d-flex flex-wrap gap-2">
              <template v-for="(label, key) in availableColumns">
                  <input type="checkbox" class="btn-check" :id="'col-'+key" :value="key" v-model="selectedColumns" autocomplete="off">
                  <label class="btn btn-outline-dark btn-sm rounded-pill px-3 py-1 small-font transition-btn" :for="'col-'+key">
                      <i class="fas fa-check me-1" v-if="selectedColumns.includes(key)"></i> {{ label }}
                  </label>
              </template>
          </div>
        </div>

        <!-- أزرار التحكم (كاملة العرض في الموبايل) -->
        <div class="d-flex flex-column flex-sm-row justify-content-end mt-4 gap-2 border-top pt-3">
          <button @click="fetchAndDistribute" class="btn btn-primary px-4 fw-bold shadow-sm py-2">
            <i class="fas fa-search ms-2"></i> عرض وتوزيع
          </button>

          <button @click="exportToExcel" class="btn btn-success px-4 fw-bold shadow-sm py-2">
            <i class="fas fa-file-excel ms-2"></i> تصدير Excel
          </button>
          
          <button @click="print" class="btn btn-dark px-4 fw-bold shadow-sm py-2" :disabled="generatedCommittees.length === 0">
            <i class="fas fa-print ms-2"></i> طباعة
          </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير (متجاوبة + طباعة) -->
    <div v-if="generatedCommittees.length > 0" id="printMe" class="print-area">
      
      <!-- حلقة تكرار اللجان -->
      <div v-for="(committee, index) in generatedCommittees" :key="index" class="committee-sheet mb-5" style="page-break-after: always;">
        
        <!-- الترويسة (متجاوبة: تصغر في الموبايل) -->
        <div class="report-header mb-3">
          <div class="row text-center border-bottom border-2 border-dark pb-2 mb-2 align-items-center g-1">
            <div class="col-4 text-start">
               <h6 class="fw-bold m-0 fs-6-sm">محافظة شمال سيناء</h6>
               <h6 class="fw-bold m-0 fs-6-sm">مديرية التربية والتعليم</h6>
               <h6 class="fw-bold m-0 fs-6-sm">لجنة النظام والمراقبة</h6>
            </div>
            <div class="col-4">
               <h3 class="fw-bold text-decoration-underline m-0 fs-5-sm">كشف مناداة</h3>
               <div class="border border-dark px-2 rounded-pill mt-1 d-inline-block small">
                 <strong>لجنة فرعية ( {{ committee.committee_no }} )</strong>
               </div>
            </div>
            <div class="col-4 text-center">
               <h6 class="fw-bold m-0 fs-6-sm">{{ season_name.name }}</h6>
            </div>
          </div>

          <div class="border border-dark p-2 text-center bg-white mb-3">
            <div class="row fw-bold fs-6 g-1">
              <div class="col-12 col-md-6 text-md-start text-center border-start-md border-dark mb-1 mb-md-0">
                 مقر اللجنة: {{ season_name.Commite_Name | truncate(30) }}
              </div>
              <div class="col-6 col-md-3 border-start border-dark">
                 العدد: {{ committee.students.length }}
              </div>
               <div class="col-6 col-md-3">
                 بداية: {{ committee.students[0].Seating_No }}
              </div>
            </div>
          </div>
        </div>

        <!-- الجدول (Scrollable on Mobile) -->
        <div class="table-responsive shadow-sm border rounded">
            <table class="table table-bordered border-dark text-center align-middle committee-table mb-0 w-100" style="min-width: 600px;">
                <thead class="bg-light">
                  <tr>
                    <!-- <th width="5%">م</th> -->
                    <th v-for="colKey in selectedColumns" :key="colKey" class="fw-bold text-nowrap">
                      {{ availableColumns[colKey] }}
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(student, sIndex) in committee.students" :key="student.id">
                    <!-- <td class="fw-bold">{{ sIndex + 1 }}</td> -->
                    
                    <td v-for="colKey in selectedColumns" :key="colKey" class="fw-bold py-1 text-nowrap fs-6">
                     <template v-if="colKey === 'Arabic_Name'">
                  <div class="d-flex flex-column align-items-start ps-2 fs-23">
                      <span>{{ student.Arabic_Name | truncate(40) }}</span>
                      
                      <!-- شارة الدمج (تظهر فقط إذا كان دمج) -->
                      <div v-if="student.Damg_Status === 'نعم' " class="mt-1 no-print-bg">
                          <span class="badge bg-warning text-dark border border-dark small-badge">
                              دمج ({{ student.disability_type || 'إعاقة' }})
                          </span>
                      </div>
                
                  </div>
              </template>
              <template v-else>
                  {{ student[colKey] }}
              </template>
                    </td>
                    
                   
                  </tr>
                </tbody>
            </table>
        </div>

        <!-- التذييل -->
        <div class="committee-footer mt-3 pt-2 px-3 border-top d-print-block">
          <div class="row text-center gy-2">
            <div class="col-4"><h6 class="fw-bold small">ملاحظ 1: ....................</h6></div>
            <div class="col-4"><h6 class="fw-bold small">ملاحظ 2: ....................</h6></div>
            <div class="col-4"><h6 class="fw-bold small">مراقب الدور: ....................</h6></div>
          </div>
        </div>
        
        <div class="page-break"></div>
      </div>

    </div>

    <!-- رسالة فارغة -->
    <div v-else class="text-center py-5 no-print text-muted">
      <div class="icon-box bg-light rounded-circle p-4 d-inline-block mb-3">
          <i class="fas fa-file-contract fa-3x opacity-25"></i>
      </div>
      <h5 class="fw-bold">بانتظار الإجراء</h5>
      <p class="small">قم باختيار إعدادات التوزيع واضغط "عرض وتوزيع"</p>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "CommitteeDistribution",
  data() {
    return {
       season_name: {},
       countStudent: 0,
       
      availableColumns: {
        'Seating_No': 'رقم الجلوس',
        'Arabic_Name': 'اسم الطالب',
       
        'Stud_Type_Desc': 'نوعية التعليم',
        'Moslem_Name': 'الديانة',
        'Male_Name': 'النوع',
     
      },
      
      selectedColumns: ['Seating_No', 'Arabic_Name', 'Stud_Type_Desc', 'Moslem_Name','Male_Name'],

      settings: {
        capacity: 20, 
        start_committee: 1, 
      
        sort_mode: 'school_gender' // القيمة الافتراضية
      },

      generatedCommittees: [] 
    };
  },
  filters: {
    truncate(value, limit) {
      if (!value) return '';
      if (value.length <= limit) return value;
      return value.substring(0, limit) + '..';
    }
  },
  methods: {   
    async fetchAndDistribute() {
      if(!this.settings.capacity) return alert("أدخل سعة اللجنة");

      try {
        const response = await api.get('/getStudentCommitteeDistribution', {
            params: { sort_mode: this.settings.sort_mode }
        });
        
        const allStudents = response.data['students'];
        this.countStudent = allStudents.length;
        this.season_name = response.data['season'] || { name: 'العام الحالي', Commite_Name: 'لجنة عامة' };

        this.distributeStudents(allStudents);

      } catch (e) {
        console.error(e);
        alert("خطأ في جلب البيانات");
      }
    },

    distributeStudents(students) {
      this.generatedCommittees = [];
      let currentCommitteeNo = this.settings.start_committee;
      let capacity = this.settings.capacity;

      // تقسيم المصفوفة
      for (let i = 0; i < students.length; i += capacity) {
        const chunk = students.slice(i, i + capacity);
        
        this.generatedCommittees.push({
          committee_no: currentCommitteeNo,
          students: chunk
        });

        currentCommitteeNo++;
      }
    },

    print() {
       const options = {
  name: '_balnk',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
 
    '/css/adminlte.rtl.css',
    '/assets/css/rtl.css',
    '/assets/css/style_committee.css',
    'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap',
   

  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
       this.$htmlToPaper("printMe", options, () => {
    console.log("Printing Done");
  });
    },
    
    async exportToExcel() {
      // تفعيل حالة التحميل (اختياري)
      // this.loading = true; 

      try {
        const response = await api.get('/export', {
          // هام جداً: هذا السطر يخبر المتصفح أن الرد عبارة عن ملف وليس نص
          responseType: 'blob', 
        });

        // 1. إنشاء رابط وهمي للملف في المتصفح
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // 2. إنشاء عنصر <a> مخفي
        const link = document.createElement('a');
        link.href = url;
        
        // 3. تحديد اسم الملف (يمكنك تغييره هنا)
        link.setAttribute('download', 'بيانات_اللجنة.xlsx');
        
        // 4. إضافته للصفحة والضغط عليه برمجياً
        document.body.appendChild(link);
        link.click();
        
        // 5. التنظيف بعد التحميل
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        // رسالة نجاح (اختياري)
        // alert("تم تحميل الملف بنجاح");

      } catch (error) {
        console.error("خطأ في تحميل الملف:", error);
        
        // محاولة قراءة رسالة الخطأ إذا كانت blob (أحياناً السيرفر يرجع json error رغم طلبنا blob)
        if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const errorObj = JSON.parse(reader.result);
                    alert(errorObj.message || "حدث خطأ أثناء التصدير");
                } catch (e) {
                    alert("فشل تحميل الملف");
                }
            };
            reader.readAsText(error.response.data);
        } else {
            alert("حدث خطأ في الاتصال بالسيرفر");
        }

      } finally {
        // this.loading = false;
      }
    },
    downloadPdf() {
  window.open(
    `http://localhost:8000/api/id`,
    "_blank"
  );
}
  }
};
</script>

<style scoped>
/* تنسيق الأزرار Toggle */
.btn-check:checked + .btn-outline-secondary {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}

/* --- تنسيقات الطباعة --- */
@media print {
  @page {
    size: A4 portrait; /* طولي لأن الكشف عادة طولي */
    margin: 10mm;
  }

  body * {
    visibility: hidden;
  }
  
  .no-print {
    display: none !important;
  }

  /* إظهار المنطقة المحددة فقط */
  .print-area, .print-area * {
    visibility: visible;
  }

  .print-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  /* تنسيق كل صفحة لجنة */
  .committee-sheet {
      page-break-after: always; /* فاصل إجباري بعد كل لجنة */
      page-break-inside: avoid;
      min-height: 95vh;
      position: relative;
  }

  /* الجدول */
  .committee-table th, .committee-table td {
      border: 1px solid #000 !important;
      font-size: 13pt !important;
      padding: 5px !important;
  }
  
  /* الأعمدة في الترويسة */
  .col-4 { width: 33.33% !important; float: right; }
  .col-6 { width: 50% !important; float: right; }
  .col-3 { width: 25% !important; float: right; }
  
  /* الخلفيات */
  .bg-light { 
      background-color: #f0f0f0 !important; 
      -webkit-print-color-adjust: exact; 
  }
}
.card-radio input:checked + label {
    background-color: #0d6efd;
    color: white;
    border-color: #0d6efd;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

</style>